import api from '../api';

const PRODUCT_CATEGORIES_URL = '/product-categories';
const PRODUCT_CATEGORIES_DETAIL_URL = '/product-categories/:id';
const PRODUCT_CATEGORIES_UNASSIGNED_PRODUCTS_URL =
  '/product-categories/unassigned-products';

export async function fetchAllProductCategories() {
  return api.get(PRODUCT_CATEGORIES_URL);
}

export async function updateProductCategory(id, data) {
  return api.put(PRODUCT_CATEGORIES_DETAIL_URL.replace(':id', id), data);
}

export async function createProductCategory(data) {
  return api.post(PRODUCT_CATEGORIES_URL, data);
}

export async function downloadUnassignedProducts() {
  const resp = await api.get(PRODUCT_CATEGORIES_UNASSIGNED_PRODUCTS_URL, {
    responseType: 'arraybuffer',
  });

  const url = window.URL.createObjectURL(new Blob([resp.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', 'unassigned-products.xlsx');
  document.body.appendChild(link);
  link.click();
}

export async function fetchProductCategoryForProduct({
  page = undefined,
  limit = undefined,
  orderBy = undefined,
  orderDirection = undefined,
  parentEntityName,
  parentEntityKey,
  parentId,
  q,
}) {
  const categories = await api.get(`entities/productCategoryCatalog`, {
    params: {
      page,
      limit,
      orderBy,
      orderDirection,
      parentEntityName,
      parentEntityKey,
      parentId,
      q,
    },
  });

  categories.data.items = categories.data.items.map((item) => {
    if (item.productCategory && !item.productCategory.isActive) {
      item.productCategory = null;
      item.productSubcategory = null;
      item.productClass = null;
      item.productSubclass = null;
    }

    if (item.productSubcategory && !item.productSubcategory.isActive) {
      item.productSubcategory = null;
      item.productClass = null;
      item.productSubclass = null;
    }

    if (item.productClass && !item.productClass.isActive) {
      item.productClass = null;
      item.productSubclass = null;
    }

    if (item.productSubclass && !item.productSubclass.isActive) {
      item.productSubclass = null;
    }

    return item;
  });

  return categories;
}

export function mapProductCategoryRequestBody(data) {
  return {
    name: data.name,
    code: data.code,
    sortPriority: data.sortPriority,
    productCategoryId: data.productCategoryId,
    productSubcategoryId: data.productSubcategoryId,
    productClassId: data.productClassId,
    productSubclassId: data.productSubclassId,
    productCategoryImage: data.productCategoryImage && {
      id: data.productCategoryImage.id,
    },
    isActive: data.isActive,
  };
}
